import { atom } from 'recoil'
import { CanvasShape } from '../../types/CanvasShape'

// TODO: This is only the the shape, which is a subset of detection. Refactor to use Detections, CurrentDetections, PreviousDetections etc across all components. to get more info like entityId
export const SelectedDetectionAtom = atom<CanvasShape | undefined>({
  key: 'selected-shape',
  default: undefined,
})
